var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmuitomais({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8428 22.0737H41.4645V11.6954C41.4645 6.34287 37.1216 2 31.7691 2C26.4166 2 22.0737 6.34287 22.0737 11.6954V22.0737H11.6954C6.34287 22.0737 2 26.4166 2 31.7691C2 37.1216 6.34287 41.4645 11.6954 41.4645H22.0737V51.8428C22.0737 57.1953 26.4166 61.5382 31.7691 61.5382C37.1216 61.5382 41.4645 57.1953 41.4645 51.8428V41.4645H51.8428C57.1953 41.4645 61.5382 37.1216 61.5382 31.7691C61.5382 26.4166 57.1953 22.0737 51.8428 22.0737Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmuitomais);
export default __webpack_public_path__ + "static/media/emuitomais.38c303ff00322aab6661ac8226480deb.svg";
export { ForwardRef as ReactComponent };